"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("@ingka/button"));
var _crossSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/cross-small"));
var _WrapListener = _interopRequireDefault(require("./utils/WrapListener"));
var _toastShared = require("@ingka/toast-shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const calculateComponentTextLength = component => {
  if (typeof component === 'string') return component.length;
  if (component.props && component.props.children) {
    return _react.Children.map(component.props.children, child => calculateComponentTextLength(child)).reduce((len, sum) => sum += len);
  }
  return 0;
};
function timeoutHook(callback, timeout) {
  const autoDismissRequest = (0, _react.useRef)();
  const setDismissTimeout = () => {
    clearTimeout(autoDismissRequest.current);
    autoDismissRequest.current = setTimeout(callback, timeout);
  };
  const clearDismissTimeout = () => clearTimeout(autoDismissRequest.current);
  return [setDismissTimeout, clearDismissTimeout];
}
const Toast = props => {
  const {
    className,
    prefix = '',
    text = '',
    actionButtonText,
    isOpen = false,
    actionClick,
    onCloseRequest,
    onTransitionEnd,
    ariaLabelCloseBtn,
    children,
    ...other
  } = props;
  const baseClass = `${prefix}toast`;
  const dismissTime = (0, _toastShared.calculateAutoDismissTime)(calculateComponentTextLength(text));
  const [isOffScreen, setIsOffScreen] = (0, _react.useState)(!isOpen);
  const [originallyFocusedElement, setOriginallyFocusedElement] = (0, _react.useState)(null);
  const [setDismissTimeout, clearDismissTimeout] = timeoutHook(onCloseRequest, dismissTime);
  const toastWrapper = (0, _react.useRef)(null);
  const customAction = (0, _react.useRef)(null);
  const dismissAction = (0, _react.useRef)(null);
  const toggleToast = (0, _classnames.default)(baseClass, isOpen && `${baseClass}--show`, isOffScreen && !isOpen && `${baseClass}--off-screen`, className);
  (0, _react.useEffect)(() => {
    setOriginallyFocusedElement(document.activeElement);
    if (isOpen) {
      if (customAction && customAction.current && customAction.current !== document.currentTarget) {
        customAction.current.focus();
      } else {
        dismissAction.current.focus();
      }
    }
    return clearDismissTimeout;
  }, [isOpen, text]);
  const {
    onMouseOver,
    onTouchStart,
    onMouseLeave,
    onTouchEnd,
    onBlur,
    onFocus
  } = other;
  const [mouseOver, touchStart, mouseLeave, touchEnd, handleBlur, handleFocus] = (0, _react.useMemo)(() => [(0, _WrapListener.default)(clearDismissTimeout, onMouseOver), (0, _WrapListener.default)(clearDismissTimeout, onTouchStart), (0, _WrapListener.default)(setDismissTimeout, onMouseLeave), (0, _WrapListener.default)(setDismissTimeout, onTouchEnd), (0, _WrapListener.default)(setDismissTimeout, onBlur), (0, _WrapListener.default)(clearDismissTimeout, onFocus)], [onMouseOver, onTouchStart, onMouseLeave, onTouchEnd, onBlur, onFocus]);
  return _react.default.createElement("div", _extends({
    className: toggleToast,
    tabIndex: "-1",
    "aria-hidden": !isOpen,
    role: actionButtonText ? 'alertdialog' : 'status'
  }, other, {
    onMouseOver: mouseOver,
    onMouseLeave: mouseLeave,
    onTouchStart: touchStart,
    onTouchEnd: touchEnd,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: toastWrapper,
    onTransitionEnd: e => {
      if (toastWrapper.current && e.propertyName === 'transform' && e.target === toastWrapper.current) {
        setIsOffScreen(!isOpen);
        if (onTransitionEnd) {
          onTransitionEnd(e);
        }
      }
    }
  }), _react.default.createElement("div", {
    className: `${baseClass}__body-wrapper`
  }, _react.default.createElement("div", {
    className: `${baseClass}__body`
  }, _react.default.createElement("p", {
    className: `${baseClass}__text`
  }, text), children), actionButtonText && _react.default.createElement("div", {
    className: `${baseClass}__action`,
    onMouseDown: e => e.stopPropagation()
  }, _react.default.createElement(_button.default, {
    small: true,
    ref: customAction,
    type: "plain",
    prefix: prefix,
    className: `${baseClass}__action-message`,
    text: actionButtonText,
    onClick: actionClick,
    tabIndex: !isOpen ? '-1' : null
  }))), _react.default.createElement("div", {
    className: `${baseClass}__close-btn`,
    onMouseDown: e => e.stopPropagation()
  }, _react.default.createElement(_button.default, {
    prefix: prefix,
    ref: dismissAction,
    iconOnly: true,
    type: "tertiary",
    inverseTheme: true,
    small: true,
    ssrIcon: _crossSmall.default,
    onClick: e => {
      onCloseRequest(e);
      originallyFocusedElement.focus();
    },
    text: ariaLabelCloseBtn,
    tabIndex: !isOpen ? '-1' : null
  })));
};
var _default = Toast;
exports.default = _default;